import { faUserCircle } from '@fortawesome/pro-regular-svg-icons/faUserCircle';
import logout from '@propertypal/shared/src/utils/logout';
import platform from '@propertypal/shared/src/utils/platform';
import { ACCOUNT_LINKS, NavLink, SIGN_IN_LINKS } from '@propertypal/web-app/src/constants/navigation';
import useProfileImage from '@propertypal/web-app/src/hooks/useProfileImage';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import ProfileAvatar from '../profile/ProfileAvatar';
import { Text } from '../typography';
import { HeaderButton, HeaderIcon, LogOutLinkButton, UserLinkBox, UserSubMenuBox } from './ProfileDropdown.style';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  loggedIn?: boolean;
  textColor: string;
}

const ProfileDropdown: FunctionComponent<Props> = (props) => {
  const profileImage = useProfileImage(props.loggedIn);
  // props.loggedIn not available on static pages
  const loggedIn = props.loggedIn || !!profileImage;
  const items = loggedIn ? ACCOUNT_LINKS : SIGN_IN_LINKS;
  const router = useRouter();
  const theme = useTheme();
  const { open, setOpen } = props;

  const toggleUserPanel = () => {
    setOpen(!open);
  };

  return (
    <>
      {!loggedIn && (
        <HeaderButton
          $active={open}
          onClick={toggleUserPanel}
          data-testid="log-in"
          style={{ borderColor: props.textColor }}
        >
          {platform.select(
            null,
            <HeaderIcon>
              <FontAwesomeIcon
                color={open ? theme.primary : props.textColor}
                style={{ fontSize: platform.select(18, 24) }}
                icon={faUserCircle}
              />
            </HeaderIcon>,
          )}

          <Text color={props.textColor} fontWeight="bold">
            Log in
          </Text>
        </HeaderButton>
      )}

      {loggedIn && (
        <HeaderButton onClick={toggleUserPanel} data-testid="my-account" style={{ borderColor: props.textColor }}>
          <HeaderIcon>
            <ProfileAvatar src={profileImage} width={platform.select(18, 24)} borderWidth={platform.select(1, 0)} />
          </HeaderIcon>

          <Text color={props.textColor} fontSize={12} fontWeight="bold">
            My Account
          </Text>
        </HeaderButton>
      )}

      {open && (
        <UserSubMenuBox data-testid="user-sub-box" role="menu" $loggedIn={loggedIn}>
          {items.map((link: NavLink) => (
            <li key={link.text} role="none" data-sub>
              {!!link.url && (
                <UserLinkBox
                  href={link.url}
                  prefetch={false}
                  shallow
                  role="menuitem"
                  data-testid={link.testID}
                  style={{ color: router?.asPath === link.url ? theme.primary : undefined }}
                >
                  {link.text}
                </UserLinkBox>
              )}

              {!link.url && (
                <LogOutLinkButton role="menuitem" onClick={() => logout()} data-testid={link.testID}>
                  {link.text}
                </LogOutLinkButton>
              )}
            </li>
          ))}
        </UserSubMenuBox>
      )}
    </>
  );
};

export default ProfileDropdown;
